import * as React from "react"
import { Flex, Text } from "@chakra-ui/react"
import { Flag } from "../../../servicesPanel/auctions/auction.styled"
import { useTranslation } from "react-i18next"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { useRecoilValue } from "recoil"
import { IoClose } from "react-icons/io5"
import { Icon } from "../../../common/icons"
import { useResizeObserver } from "../../../../hooks/useResizeObserver"
import { v4 as uuidv4 } from "uuid"
import { Logo } from "../../../header/logo"
import { CURRENT_URL } from "../../../../constants"
import FlagImages from "../../../../constants/flagImages"

interface LanguagesProps {
  isAudienceType: boolean
  isMobile: boolean
  visible: boolean
  height: number
  handleClose: () => void
  setLocalUserLanguage: any
  showHeader: boolean
}

const languages = [
  /*  {
    id: "01",
    value: "CS",
    language: "Czech",
    flag: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f1e8-1f1ff.png"
  }, */
  /*  {
    id: "02",
    value: "NL",
    language: "Dutch",
    flag: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f1f3-1f1f1.png"
  }, */
  {
    id: "03",
    value: "EN",
    language: "English",
    flag: FlagImages.EN
  },
  {
    id: "04",
    value: "FR",
    language: "French",
    flag: FlagImages.FR
  },
  {
    id: "05",
    value: "DE",
    language: "German",
    flag: FlagImages.DE
  },
  {
    id: "06",
    value: "EL",
    language: "Greek",
    flag: FlagImages.EL
  },
  {
    id: "07",
    value: "HU",
    language: "Hungarian",
    flag: FlagImages.HU
  },
  {
    id: "08",
    value: "IT",
    language: "Italian",
    flag: FlagImages.IT
  },
  {
    id: "09",
    value: "LT",
    language: "Lithuanian",
    flag: FlagImages.LT
  },
  {
    id: "10",
    value: "PL",
    language: "Polish",
    flag: FlagImages.PL
  },
  {
    id: "11",
    value: "PT",
    language: "Portuguese",
    flag: FlagImages.PT
  },
  /*  {
    id: "12",
    value: "SL",
    language: "Slovenian",
    flag: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f1f8-1f1ee.png"
  }, */
  /*   {
    id: "13",
    value: "ES",
    language: "Spanish",
    flag: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f1ea-1f1f8.png"
  },  */
  /*  {
    id: "14",
    value: "SV",
    language: "Swedish",
    flag: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f1f8-1f1ea.png"
  }, */
  {
    id: "15",
    value: "UK",
    language: "Ukrainian",
    flag: FlagImages.UK
  }
]

export const Languages: React.FC<LanguagesProps> = React.memo(
  ({
    isAudienceType,
    visible,
    isMobile,
    height,
    handleClose,
    setLocalUserLanguage,
    showHeader
  }) => {
    const { i18n, t } = useTranslation()
    const roomStyles = useRecoilValue(brandingSelector)

    const handleLanguageChange = value => {
      i18n.changeLanguage(value) //change the language
      setLocalUserLanguage(
        {
          [`language-${uuidv4()}`]: {
            language: value,
            url: CURRENT_URL
          }
        },
        "add"
      )
      handleClose()
    }

    const containerRef = React.useRef<HTMLDivElement>(null)
    const titleRef = React.useRef<HTMLDivElement>(null)

    const [, heightContainer] = useResizeObserver(containerRef)
    const [, heightTitle] = useResizeObserver(titleRef)

    const showLogo = isMobile && !showHeader && isAudienceType

    const heightLanguagesContainer = React.useMemo(
      () => heightContainer - heightTitle - (isMobile ? showLogo ? 120 : 70 : 50),
      [heightContainer, heightTitle, isMobile, showLogo]
    )

    return (
      <Flex
        alignItems="center"
        width="100%"
        className="avatar-modal"
        flexDirection="column"
        pos="relative"
        height={height}
        overflow="hidden"
        ref={containerRef}
        visibility={
          /* isAudienceType ? (visible ? "visible" : "hidden") :  */ "unset"
        }
      >
        {/*  {!isMobile && ( */}
        <Flex
          alignItems="center"
          justifyContent="center"
          width="32px"
          height="32px"
          minH="32px"
          pos={!isMobile ? "absolute" : "relative"}
          marginLeft={isMobile && "auto"}
          top={"0px"}
          right={"0px"}
          bg={roomStyles?.joinButtonBackgroundColor ?? "#1AC541"}
          textColor={roomStyles?.joinPageButtonTextColor ?? "#FFFFFF"}
          _hover={{
            backgroundColor:
              roomStyles?.joinButtonMouseoverBackgroundColor ?? "#24A840",
            textColor: roomStyles?.joinPageButtonMouseoverTextColor ?? "#FFFFFF"
          }}
          borderRadius="50%"
          onClick={handleClose}
          cursor="pointer"
        >
          <Icon src={IoClose} zIndex={1000000} fontSize="1.3rem" />
        </Flex>
        
        {showLogo && (
          <Flex alignItems="center" justifyContent="center">
            <Logo src={roomStyles?.roomHeaderIcon} />
          </Flex>
        )}
        <Flex flexDirection="column" width="100%">
          <Text
            ref={titleRef}
            fontWeight="500"
            fontSize="24px"
            margin={isMobile ? "0rem 0rem 1rem 0rem" : "1.5rem 0rem 1rem 0rem"}
            width="100%"
            color={roomStyles?.joinPagePanelTextColor ?? "#000000"}
          >
            {t("Preferred language?")}
          </Text>
          <Flex
            width="100%"
            alignItems="center"
            justifyContent="center"
            overflow="auto"
            maxHeight={heightLanguagesContainer}
          >
            <Flex
              flexDirection="column"
              width={"unset"}
              /*  overflow="auto" */
              maxHeight="100%"
              paddingBottom={"2rem"}
            >
              {languages.map(item => (
                <Flex
                  key={item.id}
                  onClick={() => handleLanguageChange(item.value)}
                  cursor="pointer"
                  marginBottom="0.6rem"
                >
                  <Flag alt={t(item.language)} src={item.flag} />
                  <Text
                    marginLeft="1rem"
                    fontWeight="400"
                    fontSize="1.2rem"
                    color={roomStyles?.joinPagePanelTextColor ?? "#000000"}
                  >
                    {t(item.language)}
                  </Text>
                </Flex>
              ))}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    )
  }
)
